/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var Kind;
(function (Kind) {
    Kind["USER"] = "User";
    Kind["SESSION"] = "Session";
    Kind["MESSAGE"] = "Message";
    Kind["CANNED"] = "CannedRemark";
    Kind["EMAIL_REPORT"] = "EmailReport";
    Kind["EMAIL_ASSIGNEE_REPORT"] = "EmailAssigneeReport";
    Kind["CALLCENTER_REPORT"] = "CallcenterReport";
    Kind["CALLCENTER_ADVISOR_INFO"] = "CallcenterAdvisorInfo";
    Kind["CHAT_REPORT"] = "ChatReport";
    Kind["CHAT_REPORT_ITEM"] = "ChatReportItem";
})(Kind || (Kind = {}));
var NewKind;
(function (NewKind) {
    NewKind["USER"] = "User";
    NewKind["SESSION"] = "Session";
    NewKind["MESSAGE"] = "Message";
    NewKind["CANNED"] = "Canned";
})(NewKind || (NewKind = {}));
var UserType;
(function (UserType) {
    UserType["CLIENT"] = "client";
    UserType["AGENT"] = "agent";
})(UserType || (UserType = {}));
var SessionState;
(function (SessionState) {
    SessionState["NO_AGENT_AVAILABLE"] = "NoAgentAvailable";
    SessionState["WAITING_FOR_RESPONSE"] = "WaitingAgentResponse";
})(SessionState || (SessionState = {}));
/**
 * User Defined Type Guards
 */
function isPayload(item) {
    return item && item.type !== undefined;
}
function isPayloaded(entity) {
    return entity.payload !== undefined;
}
function isRawMessage(item) {
    return item.payload !== undefined;
}
function getServerEntity(kind, entity) {
    return (kind === Kind.MESSAGE
        ? __assign(__assign({}, entity), { payload: JSON.stringify(entity.payload) }) : entity);
}

var METHODS;
(function (METHODS) {
    METHODS["ME"] = "GetCurrentUser";
    METHODS["CREATE"] = "Create";
    METHODS["UPDATE"] = "Update";
    METHODS["READ"] = "Read";
    METHODS["SUBSCRIBE"] = "Subscribe";
    METHODS["UNSUBSCRIBE"] = "Unsubscribe";
    METHODS["REASONS"] = "GetPauseReasons";
    METHODS["TAGS"] = "GetTagsForAgents";
    METHODS["SESSION_TAGS"] = "GetTagsForSessions";
    METHODS["CHATLIST"] = "GetChatList";
    METHODS["AGENTS_AVAILABLE"] = "IsAnyAgentAvailable";
})(METHODS || (METHODS = {}));
var CHANNELS;
(function (CHANNELS) {
    CHANNELS["CREATE"] = "entityCreated";
    CHANNELS["UPDATE"] = "entityUpdated";
    CHANNELS["REMOVE"] = "entityRemovedFromSubscription";
})(CHANNELS || (CHANNELS = {}));
var CONNECTION_STATE;
(function (CONNECTION_STATE) {
    CONNECTION_STATE["CONNECTED"] = "Connected";
    CONNECTION_STATE["CONNECTING"] = "Connecting";
    CONNECTION_STATE["DISCONNECTED"] = "Disconnected";
    CONNECTION_STATE["DISCONNECTING"] = "Disconnecting";
    CONNECTION_STATE["RECONNECTING"] = "Reconnecting";
})(CONNECTION_STATE || (CONNECTION_STATE = {}));
function isSub(obj) {
    return obj && obj.sub !== undefined && typeof obj !== 'string';
}

function makeKey(query) {
    if (query) {
        return "".concat(query.entityName, "::").concat(query.filter, "::").concat(query.orderBy, "::").concat(query.limit);
    }
    return '';
}
var ServerSubscription = /** @class */ (function () {
    function ServerSubscription(serverKey, query) {
        this.serverKey = serverKey;
        this.query = query;
        this.callbacks = [];
        this.data = [];
        this.queryKey = makeKey(query);
    }
    Object.defineProperty(ServerSubscription.prototype, "isUnused", {
        get: function () {
            return this.callbacks.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    ServerSubscription.prototype.onCreate = function (ent) {
        this.data.push(ent);
        this.broadcast();
    };
    ServerSubscription.prototype.onUpdate = function (ent) {
        var index = this.data.findIndex(function (e) { return e.id === ent.id; });
        if (index >= 0) {
            this.data.splice(index, 1, ent);
        }
        else {
            this.data.push(ent);
        }
        this.broadcast();
    };
    ServerSubscription.prototype.onDelete = function (ent) {
        var index = this.data.findIndex(function (e) { return e.id === ent.id; });
        if (index >= 0) {
            this.data.splice(index, 1);
        }
        this.broadcast();
    };
    ServerSubscription.prototype.setData = function (data) {
        this.data = data;
        this.broadcast();
    };
    ServerSubscription.prototype.setServerKey = function (key) {
        this.serverKey = key;
    };
    ServerSubscription.prototype.broadcast = function () {
        var _this = this;
        this.callbacks.forEach(function (cb) { return cb(_this.data.slice()); });
    };
    ServerSubscription.prototype.subscribe = function (cb) {
        var _this = this;
        this.callbacks.push(cb);
        if (this.data) {
            cb(this.data.slice());
        }
        return function () {
            var index = _this.callbacks.findIndex(function (e) { return e === cb; });
            if (index >= 0) {
                _this.callbacks.splice(index, 1);
            }
        };
    };
    return ServerSubscription;
}());
var Subscription = /** @class */ (function () {
    function Subscription() {
        this.callbacks = [];
    }
    Object.defineProperty(Subscription.prototype, "isUnused", {
        get: function () {
            return this.callbacks.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Subscription.prototype.setQuery = function (query) {
        this.query = query;
        this.queryKey = makeKey(query);
    };
    Subscription.prototype.setServerSub = function (sub) {
        if (sub.queryKey !== makeKey(this.query)) {
            console.warn('Mismatched Subs!');
        }
        this.serverSub = sub;
        this.canceller = this.serverSub.subscribe(this.broadcast.bind(this));
    };
    Subscription.prototype.broadcast = function (data) {
        this.callbacks.forEach(function (cb) { return cb(data.slice()); });
    };
    Subscription.prototype.subscribe = function (cb) {
        var _this = this;
        this.callbacks.push(cb);
        if (this.serverSub && this.serverSub.data) {
            cb(this.serverSub.data.slice());
        }
        return function () {
            var index = _this.callbacks.findIndex(function (e) { return e === cb; });
            if (index >= 0) {
                _this.callbacks.splice(index, 1);
            }
        };
    };
    Subscription.prototype.destroy = function () {
        if (this.canceller) {
            this.canceller();
        }
    };
    return Subscription;
}());

var CallOp;
(function (CallOp) {
    CallOp["CREATE"] = "Create";
    CallOp["UPDATE"] = "Update";
    CallOp["DELETE"] = "Delete";
})(CallOp || (CallOp = {}));
function unwrap(cb) {
    return function (list) {
        if (list[0]) {
            cb(list[0]);
        }
    };
}
function duckType(kind, update) {
    switch (kind) {
        case Kind.SESSION: {
            return __assign({ closed: false }, update);
        }
        case Kind.MESSAGE: {
            return __assign({ seen: true }, update);
        }
        case Kind.USER: {
            return __assign({ paused: false }, update);
        }
        default:
            return update;
    }
}
function rawToMessage(raw) {
    var rawPayload = JSON.parse(raw.payload);
    if (isPayload(rawPayload)) {
        switch (rawPayload.type) {
            case 'text':
                return __assign(__assign({}, raw), { payload: rawPayload });
            case 'select':
                return __assign(__assign({}, raw), { payload: rawPayload });
            case 'html':
                return __assign(__assign({}, raw), { payload: rawPayload });
            case 'modify-trip':
                return __assign(__assign({}, raw), { payload: rawPayload });
        }
    }
    return __assign(__assign({}, raw), { payload: {
            type: 'text',
            data: { message: 'Message type not supported!' },
        } });
}
var Hub = /** @class */ (function () {
    function Hub(conn) {
        var _this = this;
        this.handler = function (op, subKey, kind, entity) {
            var update = entity;
            if (isRawMessage(entity)) {
                update = rawToMessage(entity);
            }
            switch (op) {
                case CallOp.CREATE:
                    _this.serverSubs[subKey].onCreate(update);
                    break;
                case CallOp.UPDATE:
                    _this.serverSubs[subKey].onUpdate(update);
                    break;
                case CallOp.DELETE:
                    _this.serverSubs[subKey].onDelete(update);
                    break;
                default:
                    console.log('WAT');
            }
        };
        this.handleCreate = function (subKey, kind, entity) { return _this.handler(CallOp.CREATE, subKey, kind, entity); };
        this.handleUpdate = function (subKey, kind, entity) { return _this.handler(CallOp.UPDATE, subKey, kind, entity); };
        this.handleDelete = function (subKey, kind, entity) { return _this.handler(CallOp.DELETE, subKey, kind, entity); };
        this.getConnectionState = function () {
            return _this.conn.state;
        };
        this.onReconnected = function (cb) {
            return _this.conn.onreconnected(cb);
        };
        this.onReconnecting = function (cb) {
            return _this.conn.onreconnecting(cb);
        };
        this.onClose = function (cb) {
            return _this.conn.onclose(cb);
        };
        this.seeMessage = function (id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.update(Kind.MESSAGE, { id: id, seen: true, delivered: true })];
                }
            });
        }); };
        this.conn = conn;
        this.serverSubs = {};
        this.serverSubsByQuery = {};
        this.listSubs = {};
        this.started = this.conn.start().then(function () {
            _this.conn.on(CHANNELS.CREATE, _this.handleCreate);
            _this.conn.on(CHANNELS.UPDATE, _this.handleUpdate);
            _this.conn.on(CHANNELS.REMOVE, _this.handleDelete);
            _this.conn.onreconnected(_this.reconnectAllSubs.bind(_this));
            return _this.conn.invoke(METHODS.ME).then(function (me) {
                _this.me = me;
                return me;
            });
        });
    }
    Hub.prototype.stop = function () {
        this.conn.off(CHANNELS.CREATE, this.handleCreate);
        this.conn.off(CHANNELS.UPDATE, this.handleUpdate);
        this.conn.off(CHANNELS.REMOVE, this.handleDelete);
        return this.conn.stop();
    };
    Hub.prototype.registerSub = function (sub) {
        return __awaiter(this, void 0, void 0, function () {
            var query, queryKey, ref;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        _a.sent();
                        query = sub.query, queryKey = sub.queryKey;
                        if (!(query && queryKey)) return [3 /*break*/, 4];
                        if (!!this.serverSubsByQuery[queryKey]) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.conn.invoke(METHODS.SUBSCRIBE, query)];
                    case 2:
                        ref = (_a.sent()).ref;
                        this.serverSubs[ref] = new ServerSubscription(ref, query);
                        this.serverSubsByQuery[queryKey] = this.serverSubs[ref];
                        _a.label = 3;
                    case 3:
                        sub.setServerSub(this.serverSubsByQuery[queryKey]);
                        return [3 /*break*/, 5];
                    case 4:
                        console.warn('Tried to subscribe without a query!', sub);
                        return [2 /*return*/, false];
                    case 5: return [2 /*return*/, true];
                }
            });
        });
    };
    Hub.prototype.unregisterSub = function (sub) {
        return __awaiter(this, void 0, void 0, function () {
            var serverSub;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        _a.sent();
                        serverSub = sub.serverSub;
                        if (!serverSub) return [3 /*break*/, 4];
                        sub.destroy();
                        if (!serverSub.isUnused) return [3 /*break*/, 4];
                        if (!(this.getConnectionState() === CONNECTION_STATE.CONNECTED)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.conn.invoke(METHODS.UNSUBSCRIBE, serverSub.serverKey)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        delete this.serverSubsByQuery[serverSub.queryKey];
                        delete this.serverSubs[serverSub.serverKey];
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Hub.prototype.reloadSubData = function (sub) {
        return __awaiter(this, void 0, void 0, function () {
            var query, serverSub, data, update;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        _a.sent();
                        query = sub.query, serverSub = sub.serverSub;
                        if (!(query && serverSub)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.conn.invoke(METHODS.READ, query)];
                    case 2:
                        data = _a.sent();
                        update = data;
                        if (data[0] && isRawMessage(data[0])) {
                            update = data.map(rawToMessage);
                        }
                        serverSub.setData(update);
                        return [3 /*break*/, 4];
                    case 3:
                        console.warn('Tried to fetch data without a filter!', sub);
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/, true];
                }
            });
        });
    };
    Hub.prototype.reconnectAllSubs = function () {
        var _this = this;
        Object.entries(this.serverSubs).forEach(function (_a) {
            var oldKey = _a[0], sub = _a[1];
            return __awaiter(_this, void 0, void 0, function () {
                var ref, data, update;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.started];
                        case 1:
                            _b.sent();
                            return [4 /*yield*/, this.conn.invoke(METHODS.SUBSCRIBE, sub.query)];
                        case 2:
                            ref = (_b.sent()).ref;
                            sub.setServerKey(ref);
                            delete this.serverSubs[oldKey];
                            this.serverSubs[ref] = sub;
                            return [4 /*yield*/, this.conn.invoke(METHODS.READ, sub.query)];
                        case 3:
                            data = _b.sent();
                            update = data;
                            if (data[0] && isRawMessage(data[0])) {
                                update = data.map(rawToMessage);
                            }
                            sub.setData(update);
                            return [2 /*return*/];
                    }
                });
            });
        });
    };
    Hub.prototype.fetch = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var data, update;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.conn.invoke(METHODS.READ, query)];
                    case 2:
                        data = _a.sent();
                        update = data;
                        if (data[0] && isRawMessage(data[0])) {
                            update = data.map(rawToMessage);
                        }
                        return [2 /*return*/, update];
                }
            });
        });
    };
    Hub.prototype.update = function (kind, entity) {
        return __awaiter(this, void 0, void 0, function () {
            var fields, updated, payload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        _a.sent();
                        fields = Object.keys(entity).filter(function (field) { return field !== 'id'; });
                        updated = entity;
                        if (isPayloaded(entity)) {
                            payload = JSON.stringify(entity.payload);
                            updated = __assign(__assign({}, entity), { payload: payload });
                        }
                        // The backend needs some fields unique to each kind to identify them, so we add them *without* adding to the
                        // fields list
                        updated = duckType(kind, updated);
                        return [2 /*return*/, this.conn.invoke(METHODS.UPDATE, { entityName: kind, entity: updated, fields: fields })];
                }
            });
        });
    };
    Hub.prototype.create = function (kind, entity) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.conn.invoke(METHODS.CREATE, {
                                entityName: kind,
                                entity: getServerEntity(kind, entity),
                            })];
                }
            });
        });
    };
    Hub.prototype.getReasons = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.conn.invoke(METHODS.REASONS)];
                }
            });
        });
    };
    Hub.prototype.getAvailableTags = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.conn.invoke(METHODS.TAGS)];
                }
            });
        });
    };
    Hub.prototype.getAvailableSessionTags = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.conn.invoke(METHODS.SESSION_TAGS)];
                }
            });
        });
    };
    Hub.prototype.isAnyAgentAvailable = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.conn.invoke(METHODS.AGENTS_AVAILABLE)];
                }
            });
        });
    };
    Hub.prototype.getChatList = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.conn.invoke(METHODS.CHATLIST, payload)];
                }
            });
        });
    };
    Hub.prototype.fetchSessionById = function (sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetch({
                                entityName: Kind.SESSION,
                                filter: "id = ".concat(sessionId),
                            })];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result[0]];
                }
            });
        });
    };
    Hub.prototype.getSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, existing;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        me = _a.sent();
                        return [4 /*yield*/, this.fetch({
                                entityName: Kind.SESSION,
                                filter: "clientUserId = ".concat(me.id, " and closed = false and deleted = false"),
                            })];
                    case 2:
                        existing = (_a.sent());
                        return [2 /*return*/, existing[0]];
                }
            });
        });
    };
    Hub.prototype.getOrCreateSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.getOrCreateSessionProm)
                    return [2 /*return*/, this.getOrCreateSessionProm];
                this.getOrCreateSessionProm = this.internalGetOrCreateSession().then(function (session) {
                    _this.getOrCreateSessionProm = undefined;
                    return session;
                });
                return [2 /*return*/, this.getOrCreateSessionProm];
            });
        });
    };
    Hub.prototype.internalGetOrCreateSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, existing;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        me = _a.sent();
                        return [4 /*yield*/, this.getSession()];
                    case 2:
                        existing = _a.sent();
                        if (existing)
                            return [2 /*return*/, existing];
                        return [2 /*return*/, this.create(Kind.SESSION, { clientUserId: me.id })];
                }
            });
        });
    };
    Hub.prototype.subscribe = function (kind, id, cb) {
        var wrapped = function (list) {
            if (list[0]) {
                cb(list[0]);
            }
        };
        return this.subscribeList("".concat(kind, "::").concat(id), kind, wrapped, "id = ".concat(id));
    };
    Hub.prototype.subscribeList = function (subKey, kind, cb, filterPromise, orderByPromise, limitPromise) {
        var _this = this;
        if (!this.listSubs[subKey]) {
            this.listSubs[subKey] = new Subscription();
            Promise.all([filterPromise, limitPromise, orderByPromise]).then(function (_a) {
                var filter = _a[0], limit = _a[1], orderBy = _a[2];
                return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!this.listSubs[subKey]) return [3 /*break*/, 3];
                                this.listSubs[subKey].setQuery({ entityName: kind, filter: filter, orderBy: orderBy, limit: limit });
                                return [4 /*yield*/, this.registerSub(this.listSubs[subKey])];
                            case 1:
                                _b.sent();
                                return [4 /*yield*/, this.reloadSubData(this.listSubs[subKey])];
                            case 2:
                                _b.sent();
                                _b.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            });
        }
        var removeFromSub = this.listSubs[subKey].subscribe(cb);
        return function () {
            var _a;
            removeFromSub();
            if ((_a = _this.listSubs[subKey]) === null || _a === void 0 ? void 0 : _a.isUnused) {
                setTimeout(function () {
                    var _a;
                    if ((_a = _this.listSubs[subKey]) === null || _a === void 0 ? void 0 : _a.isUnused) {
                        _this.unregisterSub(_this.listSubs[subKey]);
                        delete _this.listSubs[subKey];
                    }
                }, 100);
            }
        };
    };
    Hub.prototype.subSessionMessages = function (id, cb) {
        return this.subscribeList("sessionMessages::".concat(id), Kind.MESSAGE, cb, "sessionId = ".concat(id));
    };
    Hub.prototype.fetchSessionClientMessages = function (session) {
        return this.fetch({
            entityName: Kind.MESSAGE,
            filter: "sessionId = ".concat(session.id, " AND senderUserId = ").concat(session.clientUserId),
        });
    };
    Hub.prototype.subMySessions = function (cb) {
        var _this = this;
        var filterProm = this.started.then(function (me) {
            var _a;
            return "".concat((me === null || me === void 0 ? void 0 : me.isAgent) ? UserType.AGENT : UserType.CLIENT, "UserId = ").concat((_a = _this.me) === null || _a === void 0 ? void 0 : _a.id, " AND Closed = false AND deleted = false");
        });
        return this.subscribeList('mySessions', Kind.SESSION, cb, filterProm);
    };
    Hub.prototype.subAgentSessions = function (agentId, cb) {
        return this.subscribeList("agentSessions::".concat(agentId), Kind.SESSION, cb, "agentUserId = ".concat(agentId, " AND Closed = false AND deleted = false"));
    };
    Hub.prototype.subQueueSessions = function (cb) {
        return this.subscribeList("queueSessions", Kind.SESSION, cb, "lastState = ".concat(SessionState.NO_AGENT_AVAILABLE, " AND closed = false"));
    };
    Hub.prototype.subAllOpenSessions = function (cb) {
        return this.subscribeList("allOpenSessions", Kind.SESSION, cb, "closed = false AND deleted = false");
    };
    Hub.prototype.subAllAgents = function (cb) {
        return this.subscribeList('allAgents', Kind.USER, cb, "IsAgent = true AND deleted = false");
    };
    Hub.prototype.subAllUsers = function (cb) {
        return this.subscribeList('allUsers', Kind.USER, cb, "deleted = false");
    };
    Hub.prototype.subAllCanned = function (cb) {
        return this.subscribeList('allCanned', Kind.CANNED, cb, 'deleted = false');
    };
    Hub.prototype.subMyHistory = function (cb) {
        var filterProm = this.started.then(function (me) {
            return "".concat(me.isAgent ? UserType.AGENT : UserType.CLIENT, "UserId = ").concat(me.id, " AND Closed = true AND deleted = false");
        });
        return this.subscribeList('myHistory', Kind.SESSION, cb, filterProm, 'created desc');
    };
    Hub.prototype.subClientHistory = function (id, cb) {
        return this.subscribeList("clientHistory::".concat(id), Kind.SESSION, cb, "".concat(UserType.CLIENT, "UserId = ").concat(id, " AND Closed = true AND deleted = false"), 'created desc');
    };
    Hub.prototype.subLatestEmailReport = function (inbox, cb) {
        var inboxFilter = "inbox = ".concat(inbox);
        return this.subscribeList("EmailReport::".concat(inbox, "::latest"), Kind.EMAIL_REPORT, unwrap(cb), inboxFilter, 'reportDate desc', 1);
    };
    Hub.prototype.subLatestCallcenterReport = function (callcenter, cb) {
        var callcenterFilter = "callcenter = ".concat(callcenter);
        return this.subscribeList("CallcenterReport::".concat(callcenter, "::latest"), Kind.CALLCENTER_REPORT, unwrap(cb), callcenterFilter, 'reportDate desc', 1);
    };
    Hub.prototype.subLatestChatReport = function (cb) {
        return this.subscribeList("ChatReport::latest", Kind.CHAT_REPORT, unwrap(cb), 'deleted = False', 'reportDate desc', 1);
    };
    Hub.prototype.subAssigneesForInboxAndDate = function (inbox, reportDate, cb) {
        return this.subscribeList("EmailAssignees::".concat(inbox, "::").concat(reportDate), Kind.EMAIL_ASSIGNEE_REPORT, cb, "inbox = ".concat(inbox, " AND reportDate = ").concat(reportDate), 'created desc');
    };
    Hub.prototype.subAdvisorsForCallcenterAndDate = function (callcenter, reportDate, cb) {
        return this.subscribeList("CallcenterAdvisors::".concat(callcenter, "::").concat(reportDate), Kind.CALLCENTER_ADVISOR_INFO, cb, "callcenter = ".concat(callcenter, " AND reportDate = ").concat(reportDate), 'created desc');
    };
    Hub.prototype.subChatReportItemsForDate = function (reportDate, cb) {
        return this.subscribeList("ChatReportItems::".concat(reportDate), Kind.CHAT_REPORT_ITEM, cb, "reportDate = ".concat(reportDate), 'created desc');
    };
    Hub.prototype.fetchMe = function () {
        return __awaiter(this, void 0, void 0, function () {
            var loginMe, userMe;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        loginMe = _a.sent();
                        return [4 /*yield*/, this.fetch({
                                entityName: Kind.USER,
                                filter: "id = ".concat(loginMe.id),
                            })];
                    case 2:
                        userMe = _a.sent();
                        return [2 /*return*/, userMe[0]];
                }
            });
        });
    };
    Hub.prototype.subscribeMe = function (cb) {
        var meFilter = this.started.then(function (me) {
            return "id = ".concat(me.id);
        });
        var wrapped = function (list) {
            if (list[0]) {
                cb(list[0]);
            }
        };
        return this.subscribeList('User::me', Kind.USER, wrapped, meFilter);
    };
    Hub.prototype.sendTextMessage = function (sessionId, text) {
        return __awaiter(this, void 0, void 0, function () {
            var me;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        me = _a.sent();
                        return [2 /*return*/, this.create(Kind.MESSAGE, {
                                senderUserId: me.id,
                                sessionId: sessionId,
                                payload: { type: 'text', data: { message: text } },
                            })];
                }
            });
        });
    };
    Hub.prototype.sendModifyTripMessage = function (sessionId, prompt, data) {
        return __awaiter(this, void 0, void 0, function () {
            var me;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.started];
                    case 1:
                        me = _a.sent();
                        return [2 /*return*/, this.create(Kind.MESSAGE, {
                                senderUserId: me.id,
                                sessionId: sessionId,
                                payload: { type: 'modify-trip', data: { data: data, prompt: prompt } },
                            })];
                }
            });
        });
    };
    return Hub;
}());

function makeSub(handler) {
    var _this = this;
    var val;
    var lastVal;
    var valProm;
    var queue = [];
    var subscribers = [];
    var tappers = [];
    var destroyers = [];
    var refreshers = [];
    var subSub;
    var hasValue = false;
    var flushing = false;
    var destroyed = false;
    function flush() {
        return __awaiter(this, void 0, void 0, function () {
            var nextProm;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (flushing || destroyed)
                            return [2 /*return*/]; // Only have one flushing process at a time
                        flushing = true;
                        _a.label = 1;
                    case 1:
                        if (!(queue.length > 0)) return [3 /*break*/, 4];
                        nextProm = queue.shift();
                        if (!nextProm) return [3 /*break*/, 3];
                        return [4 /*yield*/, nextProm];
                    case 2:
                        val = _a.sent();
                        hasValue = true;
                        // Now that we have a new value/subscription, we need to disconnect
                        // any of the sub-subscriptions to the previous values
                        if (subSub) {
                            subSub.destroy();
                        }
                        // For each subscriber, either pass the value, or connect to the
                        // follow along subscription
                        if (isSub(val)) {
                            subSub = val;
                            subSub.sub(function (value) { return broadcast(value); });
                        }
                        else {
                            broadcast(val);
                        }
                        _a.label = 3;
                    case 3: return [3 /*break*/, 1];
                    case 4:
                        flushing = false;
                        return [2 /*return*/];
                }
            });
        });
    }
    // A function to broadcast a computed value to all subscribers to this node
    function broadcast(outgoing) {
        lastVal = outgoing;
        subscribers.forEach(function (sub) { return sub.onNext(outgoing); });
        tappers.forEach(function (tap) { return tap(outgoing); });
    }
    // The interface object for this subscriber node
    var self = {
        // sub creates a new subscriber node as a child of this one, using
        // a mapping function that will recieve the output of this node, and
        // potentially return one of three things:
        //   - a new value (of a potentially new type)
        //   - a subscription node for a compatible value
        //   - a Promise for either of those two
        // It is also common that the mapping function is actually an end consumer,
        // in which case it most likely will return nothing.
        // Note that the sub method has a type parameter for the new output, but
        // most often that will be inferred by the mapping function.
        sub: function (cb) {
            var newSub = makeSub(cb);
            // we need to keep a list of all of the children to push values to them
            subscribers.push(newSub);
            // if this node has a value, it should supply it to the new subscriber
            // immediately
            if (hasValue) {
                newSub.onNext(lastVal);
            }
            newSub.onDestroy(function (childSub) {
                var index = subscribers.indexOf(childSub);
                if (index > -1) {
                    subscribers.splice(index, 1);
                }
            });
            return newSub;
        },
        // sel (select) works almost the same as sub, but it is more tightly tied to the original
        // subscription. It should be treated as a mapped output of the original, and destroying this object
        // will destroy the original.
        sel: function (cb) {
            var newSub = makeSub(cb);
            // we need to keep a list of all of the children to push values to them
            subscribers.push(newSub);
            // if this node has a value, it should supply it to the new subscriber
            // immediately
            if (hasValue) {
                newSub.onNext(lastVal);
            }
            newSub.onDestroy(function (childSub) {
                if (!destroyed) {
                    self.destroy();
                }
            });
            return newSub;
        },
        tap: function (cb) {
            tappers.push(cb);
            return self;
        },
        // onNext is how the subscription node will receive values from ancestors,
        // or from external sources
        onNext: function (v) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (destroyed)
                    return [2 /*return*/];
                // We accept either values, or promises for values, so we normalize here
                valProm = Promise.resolve(handler(v));
                // enqueue the promise for processing
                queue.push(valProm);
                // kick off a flush
                flush();
                return [2 /*return*/];
            });
        }); },
        // destroy "destroys" this node
        // destroy also notifies any listeners (destroyers), and tells all of
        // its children to destroy themselves
        destroy: function () {
            destroyed = true;
            destroyers.forEach(function (des) {
                des(self);
            });
            subscribers.forEach(function (subber) { return subber.destroy(); });
            if (subSub) {
                subSub.destroy();
            }
        },
        // onDestroy registers an external listener for the destroy event
        onDestroy: function (des) {
            destroyers.push(des);
        },
        // refresh tells the node to attempt to refresh its data, using external
        // sources
        refresh: function (arg) {
            refreshers.forEach(function (refresher) { return refresher(arg); });
        },
        // onRefresh registers an external handler for refreshing the data of this
        // node
        onRefresh: function (refresher) {
            refreshers.push(refresher);
        },
    };
    return self;
}

export { CONNECTION_STATE, Hub, Kind, UserType, makeSub };
//# sourceMappingURL=index.js.map
